export default {
  fetchingData: {
    id: 'bo_seller-profile-user_permission-fetching_data',
    defaultMessage: 'We are fetching your data',
  },
  noResultsTitle: {
    id: 'bo_seller-profile-user_permission-no_results_title',
    defaultMessage: 'No users user added yet',
  },
  noResultsDescription: {
    id: 'bo_seller-profile-user_permission-no_results_description',
    defaultMessage:
      'You wrok hard enough. Share the load by adding users who can help you create listings, process orders, and more.',
  },
  numberOfUsers: {
    id: 'bo_seller-profile-user_permission-number_of_users',
    defaultMessage:
      '{count} Back Office {count, plural, one {user} other {users} }',
  },
  delete: {
    id: 'bo_seller-profile-user_permission-delete',
    defaultMessage: 'Delete',
  },
  fullName: {
    id: 'global_full_name',
    defaultMessage: '{firstName} {lastName}',
  },
  edit: {
    id: 'bo_seller-profile-user_permission-edit',
    defaultMessage: 'Edit',
  },
  manageUserPermissions: {
    id: 'bo_seller-profile-user_permission-manage_user_permissions',
    defaultMessage: 'Manage user permissions',
  },
  addNewUserInfoText: {
    id: 'bo_seller-profile-user_permission-add_new_user_info_text',
    defaultMessage:
      'Add new users to your Back Office or delete existing ones.',
  },
  addNewUser: {
    id: 'bo_seller-profile-user_permission-add_new_user',
    defaultMessage: 'Add new user',
  },
  admin: {
    id: 'bo_seller-profile-user_permission-admin',
    defaultMessage: 'Admin',
  },
  reactivate: {
    id: 'bo_seller-profile-user_permission-reactivate',
    defaultMessage: 'Reactivate',
  },
}
